import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import cx from "classnames";
import { useEffect } from "react";
import { useState } from "react";
import SwiperCore, { Pagination, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Breadcrumb from "./Breadcrumb";
import OurPromise from "./OurPromise";
import ToolTip from "./ToolTip";
import WhyDifferentTable from "./WhyDifferentTable";
import Customizer from "./Customizer";
import Yotpo from "./Yotpo";
import YotpoStars from "./YotpoStars";
import { pageCopy } from "./data";
import CollagenRTB from "./CollagenRTB";
import CreatineRTB from "./CreatineRTB";
import FiberRTB from "./FiberRTB";
import HydrationRTB from "./HydrationRTB";
import PreworkoutRTB from "./PreworkoutRTB";
import ProteinRTB from "./ProteinRTB";
import Question from "./images/question.svg";
import styles from "./styles.module.scss";
import Button from "../../common/Button";
import NavBar from "../../Navigation/NavBar";
import { Footer } from "Root/checkout/components/Footer";
import CheckoutResultReviews from "Root/checkout/components/CheckoutResultsNew/CheckoutResultsReviews";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import { useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ProteinByScience from "./ProteinByScience";
import HowToUseYourSystem from "./HowToUseYourSystem";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import PersonalizedByHumans from "./PersonalizedByHumans";
import UpsellSection from "Root/quiz/components/PLP/UpsellSection";
import GreensRTB from "./GreensRTB";
SwiperCore.use([Thumbs]);
export const CUSTOMIZED_PRODUCTS = [
    "protein",
    "hydration",
    "preworkout",
    "greens",
];
const productLookup = {
    protein: "Protein Powder",
    hydration: "Hydration",
    preworkout: "Pre-Workout",
    creatine: "Creatine",
    collagen: "Collagen",
    fiber: "Fiber",
    greens: "Greens",
};
const InfoTabs = ({ howToUseCopy = "Perform at your best with hydration formulas that deliver an effective amount of electrolytes based on your workout frequency, intensity, and sweat levels.", descriptionCopy = "1. Do thing. 2. Do other thing. Etc.", }) => {
    const [value, setValue] = useState(0);
    return (_jsxs("div", { className: styles.infoTabs, children: [_jsxs("div", { className: styles.tabs, children: [_jsx(Button, { variant: "secondary", underlined: !value, onClick: () => setValue(0), children: "Description" }), _jsx(Button, { variant: "secondary", underlined: !!value, onClick: () => setValue(1), children: "How to use" })] }), _jsx("div", { className: styles.text, style: { whiteSpace: "pre-line" }, children: value === 0 ? descriptionCopy : howToUseCopy })] }));
};
export const QuantityInput = ({ value, setValue, }) => {
    return (_jsxs("div", { className: styles.quantityInput, children: [_jsx("button", { className: styles.quantityButton, onClick: () => setValue(Math.max(value - 1, 1)), children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", children: _jsx("line", { x1: "11", y1: "20", x2: "29", y2: "20", stroke: "#333333", strokeWidth: "2" }) }) }), _jsx("div", { children: value }), _jsx("button", { className: styles.quantityButton, onClick: () => setValue(value + 1), children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", children: [_jsx("line", { x1: "11", y1: "20", x2: "29", y2: "20", stroke: "#333333", strokeWidth: "2" }), _jsx("line", { y1: "-1", x2: "18", y2: "-1", transform: "matrix(0 1 1 0 21 11)", stroke: "#333333", strokeWidth: "2" })] }) })] }));
};
export const QuestionWrapper = ({ children, title, titleRight, subhed, tooltip, titleRightClass, isQuantity = false, }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [toolTipType, setToolTipType] = useState("protein_base");
    const openToolTip = (tooltip) => {
        setModalOpen(true);
        setToolTipType(tooltip);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cx(styles.questionWrapper, {
                    [styles.isQuantity]: isQuantity,
                }), children: [_jsxs("div", { className: styles.title, style: { marginBottom: subhed ? "4px" : "16px" }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [title, " ", !!tooltip && (_jsx("a", { onClick: () => openToolTip(tooltip), children: _jsx("img", { src: Question, alt: "question mark", height: 20, width: 20, className: styles.questionIcon }) }))] }), !!titleRight && (_jsx("div", { className: cx(styles.titleRight, titleRightClass), children: titleRight }))] }), subhed && _jsx("div", { className: styles.subhed, children: subhed }), children] }), _jsx(ToolTip, { data_key: toolTipType, open: modalOpen, closeModal: () => setModalOpen(false) })] }));
};
export const Carousel = ({ tapeText, images = [], }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (_jsxs("div", { className: styles.carousel, children: [_jsx(Swiper, { spaceBetween: 0, slidesPerView: 1, onSlideChange: () => { }, onSwiper: (swiper) => { }, pagination: { clickable: true }, modules: [Pagination, Thumbs], className: styles.productCarousel, thumbs: { swiper: thumbsSwiper }, loop: true, children: images.map((img, i) => (_jsx(SwiperSlide, { children: _jsx("img", { src: img, alt: "example photo", style: { objectFit: "contain", width: "100%", height: "100%" } }) }, i))) }), _jsx("div", { className: styles.thumbContainer, children: _jsx(Swiper, { spaceBetween: 10, slidesPerView: 4.5, freeMode: true, watchSlidesProgress: true, 
                    // @ts-ignore
                    onSwiper: setThumbsSwiper, threshold: 1, children: images.map((img) => (_jsx(SwiperSlide, { children: _jsx("img", { src: img, alt: "example photo", style: { objectFit: "cover" }, width: 100, height: 100 }) }))) }) })] }));
};
const findElementWithText = (text, rootNode = document.body) => {
    const elements = Array.from(rootNode.getElementsByTagName("*"));
    return elements.find((element) => element.textContent?.includes(text));
};
const replaceText = () => {
    const node = document.querySelector(".yotpo.bottomLine.review-stars .text-m");
    if (!node)
        return;
    const element = findElementWithText(" Reviews");
    if (element && element.textContent) {
        const num = parseInt(element.textContent, 10);
        if (!isNaN(num)) {
            element.textContent = `(${Math.round(num / 1000)}k+)`;
        }
    }
};
const PDP = () => {
    const userCart = useSelector((state) => state.userCart);
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const params = useParams();
    const user = useSelector((state) => state.user);
    const productString = params.product;
    const productType = productString.toUpperCase();
    const copy = pageCopy[productType] || {};
    const screen = useScreenWidth();
    const isMobile = screen < 968;
    const carouselImages = isMobile ? copy.carouselMobile : copy.carouselDesktop;
    const updateReviewsLabel = () => {
        const reviews = document.querySelectorAll("a.text-m");
        reviews.forEach((item) => {
            const text = item.textContent;
            if (text && text.toLowerCase().indexOf("reviews") > -1) {
                const reviewsCount = text.split(" ")[0] || "";
                item.textContent = reviewsCount ? ` (${reviewsCount})` : "";
                item.style.marginLeft = "8px";
            }
        });
    };
    const getCustomizerValues = () => {
        const hasItemsInCart = userCart.find((item) => item.item_type.toUpperCase() === productType);
        if (!hasItemsInCart) {
            return null;
        }
    };
    const itemsInCart = userCart.map((item) => item.item_type);
    useEffect(() => {
        setTimeout(() => {
            updateReviewsLabel();
        }, 1000); // wait till render (hopefully)
        dispatch(LoadUserCartThunk());
    }, []);
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [pathname]);
    return (_jsxs(_Fragment, { children: [_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data }), _jsx(Breadcrumb, { links: [
                    { title: "Products", href: "/app/products" },
                    {
                        title: productLookup[productString],
                        href: "/products/".concat(productString),
                    },
                ] }), _jsxs("div", { className: styles.flexContainer, children: [_jsx(Carousel, { tapeText: copy.tape, images: carouselImages }), _jsxs("div", { className: styles.body, children: [_jsxs("div", { className: styles.header, children: [_jsx("div", { className: styles.hed, children: copy.hed }), _jsx("div", { className: styles.reviews, children: productType !== "greens" && (_jsx(YotpoStars, { product: productString })) })] }), _jsx("div", { className: styles.infoTabs, children: _jsx(InfoTabs, { howToUseCopy: copy.howToUse, descriptionCopy: copy.dek }) }), _jsx(Customizer, { productType: productType })] })] }), _jsx("div", { className: styles.nutritionDrawer }), _jsx("div", { className: styles.cartDrawer }), productString === "greens" && _jsx(GreensRTB, {}), productString === "creatine" && _jsx(CreatineRTB, {}), productString === "fiber" && _jsx(FiberRTB, {}), productString === "collagen" && _jsx(CollagenRTB, {}), productString === "preworkout" && _jsx(PreworkoutRTB, {}), productString === "hydration" && _jsx(HydrationRTB, {}), productString === "protein" && (_jsxs(_Fragment, { children: [_jsx(ProteinByScience, {}), _jsx(ProteinRTB, {})] })), CUSTOMIZED_PRODUCTS.includes(productString) && (_jsx(HowToUseYourSystem, { product: productString })), _jsx(OurPromise, {}), CUSTOMIZED_PRODUCTS.includes(productString) && (_jsx(WhyDifferentTable, { product: productString })), _jsx(CheckoutResultReviews, {}), _jsx(PersonalizedByHumans, {}), _jsx(UpsellSection, { toExclude: [productString, ...itemsInCart] }), _jsx(Yotpo, { product: "protein", price: "4500" }), _jsx(Footer, {})] }));
};
export default PDP;
